import {useState, useEffect} from "react"
import {Config} from "../Config/config"

export const useLanguages = () => {
  const [languages, setLanguages] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await fetch(
          `${Config.ApiBaseUrl}/language/?firm=2&is_active=true`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${Config.Token}`,
            },
          }
        )
        if (!response.ok) throw new Error("Veri alınamadı!")

        const data = await response.json()
        setLanguages(data) // Set the fetched data
      } catch (err) {
        setError(err.message) // Handle error
      } finally {
        setLoading(false) // Loading finished
      }
    }

    fetchLanguages()
  }, [])

  return {languages, loading, error}
}
